export default {
    content:
        "p-5 bg-stone-0 dark:bg-stone-900 border border-t-0 border-stone-200 dark:border-stone-700 text-stone-700 dark:text-stone-0/80",
};
